import { z } from "zod";

export const RECORD_MENTION_DEBOUNCE_MS = 2000;
export const MENTION_SNIPPET_MAX_LENGTH = 180;
export const MENTION_ID_PREFIX = "Mention-";
export const FOCUS_MENTION_ANCHOR_EVENT = "illumi:focus-mention-anchor";

export const mentionFocusCardTypeSchema = z.enum(["card", "preprint"]);
export type MentionFocusCardType = z.infer<typeof mentionFocusCardTypeSchema>;

export const mentionFocusCardIdSchema = z.object({
	id: z.string(),
	type: mentionFocusCardTypeSchema,
});
export type MentionFocusCardId = z.infer<typeof mentionFocusCardIdSchema>;

export const focusMentionAnchorEventDetailSchema = z.object({
	anchorId: z.string(),
	cardId: mentionFocusCardIdSchema.nullable(),
});
export type FocusMentionAnchorEventDetail = z.infer<
	typeof focusMentionAnchorEventDetailSchema
>;
